import React from 'react'
import View from 'components/View'
import trimStringUtil from 'utils/string/trim'
import removeNbspStringUtil from 'utils/string/remove-nbsp'

/**
 * @param props
 * @param props.shortDescription
 * @return {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarShortDescription (props) {
  const { shortDescription } = props
  const html = (
    trimStringUtil(
      removeNbspStringUtil(shortDescription)
    )
  )

  return (
    <View
      className='quick-shop-product-sidebar-short-description'
    >
      <div
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </View>
  )
}
